import React, {useState, useEffect} from "react";

import DatePicker, { registerLocale, setDefaultLocale } from  "react-datepicker";
import  { uk } from 'date-fns/locale/uk';

registerLocale('uk', uk);



function DatePickerCalendar({ value, dateFormat= "dd.MM.YYYY", onChange }){
   

    const CustomInput = ({ value, onClick, onChange})=>{
        return (
            <input
                    type="text"
                    className="form-control with-calendar"
                    value={value}
                    onChange={onChange}
                    placeholder="дд.мм.рррр"
                    onClick={onClick}
                    readOnly
                  />
        )
    }

    return(
        <DatePicker
            locale="uk"
            selected={value}
            dateFormat={dateFormat}
            onChange={onChange}
            customInput={<CustomInput />}
        />
    )
};

export default DatePickerCalendar;

